import { fork } from 'redux-saga/effects';
import commonSaga from 'modules/common/sagas';
import generalSaga from 'modules/general/sagas';
import advertisersSaga from 'modules/advertisers/sagas';
import campaignsSaga from 'modules/campaigns/sagas';
import advertsSaga from 'modules/adverts/sagas';

function* rootSaga() {
  yield fork(commonSaga);
  yield fork(generalSaga);
  yield fork(advertisersSaga);
  yield fork(campaignsSaga);
  yield fork(advertsSaga);
}

export default rootSaga;
